/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import { apiFetch } from '../../../apiClient';
import history from '../../../utils/history';
import paths from '../../../config/path';
import { apiMap } from '../../../config/constants';
import * as CompanyRegistrationAction from '../state/action';
import { getBusandqs } from '../../App/state/action';
import BasePage from '../../../shared/BasePage';
import CompanyRegistrationItem from '../components/CompanyRegistrationItem';
import { Grid } from 'react-bootstrap';
import StepIndicator from '../../../shared/StepIndicator';
import FormTitle from '../../../shared/AOForm/components/FormTitle';
import AOForm from '../../../shared/AOForm';
import { characterNnumber } from '../../../utils/ValidationUtils';
import { setTitle, getCountryListFormLang } from '../../../utils';
import { showLoaing, saveCountryList } from '../../App/state/action';

import '../style/CompanyRegistration.css'
/* eslint-disable array-callback-return */
class CompanyRegistration extends BasePage {
    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            errorList: [],
            errorMsgs: {}
        }
    }

    componentDidMount(){
        this.getDefaultAnswer(this.props);
        this.loadContentMessage();
        
    }
    componentWillReceiveProps = (nextProps) => {
        if (nextProps.appInfo !== this.props.appInfo) {
            this.getDefaultAnswer(nextProps);
        }
        if (nextProps.selectedLanguage !== this.props.selectedLanguage) {
            this.loadContentMessage();
            this.setState({
                errorList: [],
                errorMsgs: {}
            })
        }
    }
    loadContentMessage = () => {
        apiFetch(apiMap.companyRegistrationI18n)().then((i18n) => {
            if (i18n) {
                const { allCountryDatas, selectedLanguage } = this.props;
                this.setState({ 
                    i18n,
                    staticData: getCountryListFormLang(allCountryDatas, selectedLanguage)
                 });
            }

        }).catch(error => {});   
    };

    getDefaultAnswer = (props) => {
        const { businessInfo, countryListDatas, appInfo } = props;
        const { currentSection } = this.state;
        if (countryListDatas) {
            this.setState({
                staticData: countryListDatas
            });
        }
        if (businessInfo && appInfo){
            const { companyInfo } = businessInfo;
            if (currentSection) {
                this.setState({
                    currentSection: Object.assign({}, companyInfo, currentSection),
                    oldComDocNum: (companyInfo && companyInfo.comDocNum) || null
                })
            } else {
                this.setState({
                    currentSection: {
                        registerCountry: (companyInfo && companyInfo.registerCountry) || '',
                        comDocType: (companyInfo && companyInfo.comDocType) || '',
                        comDocNum: (companyInfo && companyInfo.comDocNum) || '',
                        offShore: (companyInfo && companyInfo.offShore) || true
                    },
                    oldComDocNum: (companyInfo && companyInfo.comDocNum) || null
                })
            }
        }
    }

    onChangeAnswerForm = (value, type) => {
        const { errorList, currentSection } = this.state;
        const itemIndex = errorList.indexOf(type);
        (itemIndex !== -1) && errorList.splice(itemIndex, 1);
        if ((type === 'registerCountry' && value !=='CN') || 
            (type === 'comDocType' && value !== currentSection['comDocType'])
        ) {
            this.removeErrorList(errorList, 'comDocNum');
        }
        if ((type === 'registerCountry' || type === 'comDocType') && value === '000') {
            currentSection[type] = '';
        } else if (type === 'comDocNum') {
            currentSection[type] = characterNnumber(value);
        } else {
            currentSection[type] = value;
        }
        this.setState({
            currentSection
        });
    };
    onBlurAction = (value, type) => {
        const { errorList } = this.state;
        this.isValid(value, type);
        this.setState({
            errorList
        });
    }
    validateForm = () => {
        return new Promise((resolve, reject) => {
            const { currentSection, errorList } = this.state;
            const completeSection = JSON.parse(JSON.stringify(currentSection));
            if (completeSection.registerCountry !== 'CN') delete completeSection.comDocType;
            this.validateQuestion(completeSection, errorList);
            this.setState({
                errorList
            }, () => {
                const { errorList } = this.state;
                if (errorList && errorList.length > 0) {
                    reject && reject(errorList)
                } else {
                    resolve && resolve(completeSection)
                }
            });
        });
    }
    removeErrorList = (errorList, errorItem) => {
        const index = errorList.indexOf(errorItem);
        if (index !== -1) {
            errorList.splice(index, 1);
        }
    }
    addError = (errorList, errorItem) => {
        if (errorList.indexOf(errorItem) === -1) {
            errorList.push(errorItem);
        }
    }
    isValid = (value, key) => {
        const { errorList, errorMsgs, i18n, currentSection} = this.state;
        const requireMsg = i18n.requireMsg;
        if (
            (value === '' || value === null)
        ) {
            if (key === 'comDocNum' && currentSection['registerCountry'] !=='CN') {
                this.removeErrorList(errorList, key);
            } else {
                this.addError(errorList, key);
                errorMsgs[key] = requireMsg;
            }
        } else if (key === 'comDocNum' && currentSection['registerCountry'] === 'CN'){
            if (currentSection['comDocType'] === '1' && currentSection['comDocNum'].length !== 18) {
                this.addError(errorList, key);
                errorMsgs[key] = i18n.comDocNum.errorMsg;
            } else  if (currentSection['comDocType'] === '2' && currentSection['comDocNum'].length !== 15) {
                this.addError(errorList, key);
                errorMsgs[key] = i18n.comDocNum.errorMsg15;
            }
            
        } else {
            this.removeErrorList(errorList, key);
        };
    }
    validateQuestion = (currentSection, errorList) => {
        currentSection && Object.keys(currentSection).forEach(key => {
            this.isValid(currentSection[key], key);
        })
    }

    onChangeNextSubmit = () => {
        this.validateForm()
        .then((currentSection) => {
            const { businessInfo, appInfo } = this.props;
            const { registerCountry } = currentSection;
            const { oldComDocNum } = this.state;
            if (registerCountry === 'CN') currentSection.offShore = false;
            businessInfo.companyInfo = currentSection;
            appInfo.companyInfo = currentSection;
            const channelId = appInfo && appInfo.channelId;
            const answerDetails = businessInfo && businessInfo.answerDetails;
            if (currentSection.comDocNum !== oldComDocNum) {
                let initAnswerDetails = null;
                if(channelId === "ePort") {
                    initAnswerDetails = {
                        ...answerDetails,
                        entityType: null,
                        visitPer: null,
                        referralName: null,
                        repeatAccount: null
                    }
                } else {
                    initAnswerDetails = {
                        accountLocation: null,
                        annturnoverVersionFive: null,
                        busiNature: null,
                        companyNameC: null,
                        companyNameE: null,
                        entityType: null,
                        majorBusiCountry: null,
                        numbeOfOwner: null,
                        referralEmail: null,
                        referralName: null,
                        repeatAccount: null,
                        visitPer: null,
                        bearer: null,
                        businessSetUp: null,
                        companyType: null,
                        complexArrange: null,
                        finanIns: null,
                        gamingIndus: null,
                        stockExchange: null 
                    }
                }
                return this.props.savePQForm({
                    companyInfo: {...currentSection},
                    answerDetails: initAnswerDetails
                    // answerDetails: {
                    //     accountLocation: null,
                    //     annturnoverVersionFive: null,
                    //     busiNature: null,
                    //     companyNameC: null,
                    //     companyNameE: null,
                    //     entityType: null,
                    //     majorBusiCountry: null,
                    //     numbeOfOwner: null,
                    //     referralEmail: null,
                    //     referralName: null,
                    //     repeatAccount: null,
                    //     visitPer: null,
                    //     bearer: null,
                    //     businessSetUp: null,
                    //     companyType: null,
                    //     complexArrange: null,
                    //     finanIns: null,
                    //     gamingIndus: null,
                    //     stockExchange: null 
                    // }
                });
            } else {
                this.props.savePQForm({companyInfo: {...currentSection}});
                this.nextAction();
            }
        })
        .then(response => {
            const { currentSection, oldComDocNum } = this.state;
            const { retrvInfo, sectionInfo, countryListDatas, industryLevelList, appInfo, resOrBusOpeSitCodeLevelDatasRoots } = this.props;
            if (currentSection.registerCountry === 'CN' && currentSection.comDocNum !== oldComDocNum) {
                this.props.getQianHai(currentSection.comDocNum)
                    .then(response => {
                        return this.props.getBusandqs(appInfo, retrvInfo, countryListDatas, industryLevelList, sectionInfo, resOrBusOpeSitCodeLevelDatasRoots);
                    })
                    .then(response => {
                        this.nextAction();
                    })
                    .catch(error => {
                        // this.nextAction();
                        throw error
                    });
            } else {
                this.nextAction();
            }
        })
        .catch(error => {
        });
    }
    nextAction = () => {
        this.props.showLoaing(false);
       this.props.updateStep({"progressIndex": 1, "status": 1});
       history.push(paths.basicInfo.path); 
    }
    backAction = () => {
        history.push(paths.applicantInformation.path);
    }
    render() {
        const { appMessages, selectedLanguage, pageTitle } = this.props;
        const { currentSection, i18n, errorMsgs, errorList, disabled, staticData } = this.state;
        
        if (i18n && pageTitle) {
          setTitle( i18n.title + pageTitle);
        }

        return (i18n && currentSection) ? (
            <Grid className="dynamic-form ao-form pq-form">
                <StepIndicator currentStep={2} totalStep={5} stepInfo={appMessages.stepInfo} stepTitle={appMessages.stepTitle} />
                <FormTitle content={{
                    title: {
                        text: i18n.title,
                        dataKey: 'company-registration-title'
                    },
                    subTitle: {
                        //text: <FormattedHTMLMessage id="subTitle" defaultMessage={i18n.subTitle} />,
                        text: i18n.subTitle,
                        dataKey: 'company-registration-subTitle'
                    },
                    optional_msg: { text: appMessages.form_base_content.optional_msg, dataKey: "optional_msg"}
                }} />

                <div className="company-registration-container">
                   <CompanyRegistrationItem
                        onChangeAnswerForm={this.onChangeAnswerForm}
                        currentSection={currentSection}
                        errorList={errorList}
                        errorMsgs={errorMsgs}
                        i18n={i18n}
                        staticData={staticData}
                        selectedLanguage={selectedLanguage}
                        onBlurAction={this.onBlurAction}
                    />
                </div>
                <AOForm.BottomButtonsGroup
                    disabled={disabled}
                    saveButtonShow = {false}
                    content={i18n.bottomButtonsContent}
                    backAction={this.backAction}
                    completeFormAction={this.onChangeNextSubmit}
                />
            </Grid>
        ) : null
    }
}

CompanyRegistration.propTypes = {
    i18n: PropTypes.object
};

const mapStateToProps = (state) => ({
    appInfo: state.app.applicationInfo,
    retrvInfo: state.app.retrvInfo,
    sectionInfo: state.app.sectionInfo,
    businessInfo: state.app.businessInfo,
    selectedLanguage: state.app.selectedLanguage,
    appMessages: state.app.i18n,
    countryListDatas: state.app.countryListDatas,
    industryLevelList: state.app.industryLevelList,
    allCountryDatas: state.app.allCountryDatas,
    pageTitle: state.app.i18n.pageTitle
});

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators(CompanyRegistrationAction, dispatch),
        getBusandqs: bindActionCreators(getBusandqs, dispatch),
        showLoaing: (value) => dispatch(showLoaing(value)),
        saveCountryList: (value, lang) => dispatch(saveCountryList(value, lang))
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompanyRegistration);


// WEBPACK FOOTER //
// ./src/views/CompanyRegistration/container/CompanyRegistration.js